/**
 * Payment row English/Spanish field accessors and save normalization.
 * DB columns `client`, `date`, `createdAt` are English after dbEnglishMigration;
 * `monto` and `medio` remain Spanish in SQLite. API responses dual-key both sides.
 */
type Row = Record<string, unknown>;

/** DB/API bilingual pairs (first three also in dbEnglishMigration COLUMN_RENAMES). */
export const PAYMENT_BILINGUAL_PAIRS: [string, string][] = [
  ['client', 'cliente'],
  ['date', 'fecha'],
  ['createdAt', 'fechaCreacion'],
  ['amount', 'monto'],
  ['method', 'medio'],
];

export function paymentClient(row: Row | null | undefined): string {
  return String(row?.client ?? row?.cliente ?? '').trim();
}

export function paymentDate(row: Row | null | undefined): string {
  return String(row?.date ?? row?.fecha ?? '');
}

export function paymentAmount(row: Row | null | undefined): number {
  return Number(row?.amount ?? row?.monto) || 0;
}

export function paymentMethod(row: Row | null | undefined): string {
  return String(row?.method ?? row?.medio ?? '');
}

export function paymentCreatedAt(row: Row | null | undefined): string {
  return String(row?.createdAt ?? row?.fechaCreacion ?? '');
}

/** Normalize POST/PUT bodies from forms (Spanish) or API clients (English). */
export function normalizePaymentBody(body: Row): Row {
  const client = paymentClient(body);
  const date = paymentDate(body);
  const amount = paymentAmount(body);
  const method = paymentMethod(body);
  const createdAt = paymentCreatedAt(body);
  const clientId = body.client_id ?? body.clienteId;

  return {
    ...body,
    client,
    cliente: client,
    date,
    fecha: date,
    amount,
    monto: amount,
    method,
    medio: method,
    createdAt,
    fechaCreacion: createdAt,
    client_id: clientId,
    clienteId: clientId,
  };
}
